<template>
  <b-tab
    id="tab2"
    title="เอกสารแนบ"
  >
    <b-row
      v-for="item in attachFiles"
      :key="item.date"
    >

      <b-col
        cols="6"
        class="mt-2"
      >
        <h3>{{ item.date }}</h3>

      </b-col>

      <b-col
        cols="6"
        class="mt-2"
      >
        <h3>จำนวนการดาวน์โหลด</h3>
      </b-col>

      <hr>
      <b-row
        v-for="file in item.files"
        :key="file.name"
        class="col-12 m-1"
      >

        <b-col md="6">
          <a href="#">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24px"
              height="24px"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-arrow-down-circle"
            ><circle
              cx="12"
              cy="12"
              r="10"
            /><polyline points="8 12 12 16 16 12" /><line
              x1="12"
              y1="8"
              x2="12"
              y2="16"
            /></svg>
            {{ file.name }}
          </a>

        </b-col>
        <b-col
          cols="6"
          class="d-flex justify-content-center"
        >
          {{ file.downloadCount }}
        </b-col>
      </b-row>

    </b-row>

    <b-row class="mt-2">
      <b-col cols="12 mt-2">
        <h4>แนบเอกสารเพิ่มเติม</h4>

      </b-col>
      <b-col md="6">
        <b-form-select
          v-model="selected"
          :options="attachTypes"
          class=""
        />

      </b-col>
      <b-col md="6">
        <b-form-file
          placeholder="Choose a file or drop it here..."
          drop-placeholder="Drop file here..."
        />
      </b-col>
      <b-col
        md="12"
        class="mt-2 d-flex justify-content-center"
      >
        <b-button variant="primary">
          Upload
        </b-button>
      </b-col>

    </b-row>

  </b-tab>
</template>

<script>

import {
  BRow, BCol, BFormTextarea, BFormGroup, BFormInput, BTab, BTabs, BCard, BFormSelect, BButton, BFormFile,
} from 'bootstrap-vue'
import CommonTable from '../../../table/vue-good-table/CommonTableLawGroup.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormTextarea,
    BFormGroup,
    BFormInput,
    BTab,
    BTabs,
    BCard,
    BFormSelect,
    BButton,
    BFormFile,
    CommonTable,
  },
  data() {
    return {
      attachFiles: [
        {
          date: '01/01/2564',
          files: [{
            name: 'file1.pdf',
            downloadCount: 3,
          },
          {
            name: 'file2.pdf',
            downloadCount: 0,
          },
          {
            name: 'file3.pdf',
            downloadCount: 1,
          }],
        }, {
          date: '16/04/2564',
          files: [{
            name: 'file1.pdf',
            downloadCount: 9,
          },
          {
            name: 'file2.pdf',
            downloadCount: 15,
          },
          {
            name: 'file3.pdf',
            downloadCount: 2,
          }],
        },
      ],
      attachTypes: [
        { value: null, text: 'ประเภทเอกสาร', disabled: true },
        { text: 'ประเภท1', value: 1 },
        { text: 'ประเภท2', value: 2 },
        { text: 'ประเภท3', value: 2 },
      ],
      selected: null,
    }
  },
}
</script>

<style>

</style>
